import keycloak from '../Keycloak';

const TOKEN_MIN_VALIDITY_SECONDS = 60;
const LOGOUT_REDIRECT_URI = process.env.REACT_APP_AUTH_LOGOUTURL || window.location.origin;

let isLoggingOut = false;

const logoutOnSessionExpired = () => {
  if (isLoggingOut || !keycloak.authenticated) {
    return;
  }
  isLoggingOut = true;
  keycloak.logout({ redirectUri: LOGOUT_REDIRECT_URI });
};

export const ensureFreshAuthToken = async (minValidity = TOKEN_MIN_VALIDITY_SECONDS) => {
  if (!keycloak.authenticated) {
    return null;
  }

  try {
    await keycloak.updateToken(minValidity);
    return keycloak.token || null;
  } catch {
    logoutOnSessionExpired();
    return null;
  }
};

const setupAuthInterceptors = (api, setAuthToken) => {
  api.axiosInstance.interceptors.request.use(
    async (config) => {
      const token = await ensureFreshAuthToken();
      if (token) {
        setAuthToken(token);
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const isUnauthorized = error.response?.status === 401;

      if (!isUnauthorized || !originalRequest || originalRequest._retry || !keycloak.authenticated) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        await keycloak.updateToken(-1);
        const token = keycloak.token;
        if (!token) {
          logoutOnSessionExpired();
          return Promise.reject(error);
        }

        setAuthToken(token);
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api.axiosInstance(originalRequest);
      } catch (refreshError) {
        logoutOnSessionExpired();
        return Promise.reject(refreshError);
      }
    }
  );
};

export default setupAuthInterceptors;
